import Api from "../Api"



const getAll = async (search, tiposServicosId, filtros) => {

    try {


        let urlParams = []
        if (search != undefined && search != null) {
            urlParams.push('search=' + search)
        }
        if (filtros?.agendavel == 1) {
            urlParams.push('agendavel=1')
        }

        if (filtros?.precoVariavel == 1) {
            urlParams.push('precoVariavel=1')
        }
        if (tiposServicosId != undefined && tiposServicosId != null) {

            if (typeof tiposServicosId == 'number') {
                urlParams.push('tiposServicosId=' + tiposServicosId)
            } else if (typeof tiposServicosId == 'object') {
                tiposServicosId.map((item) => {
                    urlParams.push('tiposServicosId[]=' + item)
                })
            }


        }

        urlParams = urlParams.join('&')
        const { data } = await Api.get('/servicos?' + urlParams)
        if (data) {
            return data;
        }
    } catch (error) {
        console.log(error)
    }



}
const getById = async (idServico) => {

    try {
        const { data } = await Api.get('/servicos/' + idServico)
        if (data) {
            return data;
        }
    } catch (error) {
        console.log(error)
    }

}
const store = async (dataForm) => {


    try {
        const { data } = await Api.post('/servicos', dataForm)

        console.log(data)
        return data
    } catch (error) {
        console.log(error)
        return error
    }

}
const updateById = async (idServico, dataForm) => {
    try {
        const { data } = await Api.post('/servicos/' + idServico, dataForm)
        return data;
    } catch (error) {
        console.log(error)
        return error
    }


}
const deleteById = async (idServico) => {

    try {
        const { data } = await Api.delete('/servicos/' + idServico)
        return data;
    } catch (error) {
        console.log(error)
        return error
    }

}


const getProfissionaisVinculados = async (idServico, search, filtros) => {

    let urlParams = []
    if (search != undefined) {
        urlParams.push("search=" + search);
    }

    if (filtros?.profissionaisId) {
        urlParams.push("profissionaisId=" + filtros?.profissionaisId);
    }
    if (filtros?.agruparPorProfissional) {
        urlParams.push("agruparPorProfissional=" + filtros?.agruparPorProfissional);
    }
    try {
        const { data } = await Api.get('/servicos/' + idServico + '/profissionais?' + urlParams.join('&'))
        return data;
    } catch (error) {
        console.log(error)
        return error;
    }
}
const vincularProfissionais = async (idServico, dataForm) => {
    try {
        const { data } = await Api.post('/servicos/' + idServico + '/profissionais', dataForm)
        return data
    } catch (error) {
        return error
    }
}

export const ServicosService = {
    store,
    getAll,
    getById,
    updateById,
    deleteById,
    vincularProfissionais,
    getProfissionaisVinculados
}